import type { FC, PropsWithChildren } from 'react'

import { useTranslation } from 'react-i18next'
import styled, { css } from 'styled-components'

const StyledTableContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  .cell {
    padding: 8px 0;
    ${({ theme }) => css(theme.variants.body1.regular)};
    width: 25%;
    &:first-child {
      width: 50%;
    }
  }
  .tableHeader {
    ${({ theme }) => css(theme.variants.body2.medium)};
    width: 25%;
    word-break: break-word;
    &:first-child {
      width: 50%;
    }
  }
  .tableRow {
    display: flex;
    width: 100%;
    border-bottom: 1px solid ${({ theme }) => theme.color.lightGrey};
    &.indented-parent {
      border-bottom: 0;
    }
    &.indented {
      padding-left: 5px;
      border-bottom: 1px solid ${({ theme }) => theme.color.lightGrey};
    }
    &:first-child,
    &:last-child {
      border-bottom: 0;
    }
    .cell {
      ${({ theme }) => css(theme.variants.body2.regular)};
      &.greyed {
        color: ${({ theme }) => theme.color.grey};
      }
    }
  }

  margin-bottom: ${({ theme }) => theme.spacings.xSmall};
`

interface NutrientsInfoTableHeader {
  index: number
  headerI18nKey: string
}

interface NutrientsInfoTableProps {
  headers: NutrientsInfoTableHeader[]
}

export const NutrientInfoTable: FC<PropsWithChildren<NutrientsInfoTableProps>> = ({
  headers,
  children,
}) => {
  const { t } = useTranslation()

  return (
    <StyledTableContainer>
      <div className="tableRow">
        {headers.map(({ headerI18nKey, index }) => (
          <div key={index} className="tableHeader">
            {t(headerI18nKey)}
          </div>
        ))}
      </div>
      {children}
    </StyledTableContainer>
  )
}
